export const SCOPED_PATHS = ["/clinic", "/customers", "/team", "/settings", "/billing", "/more"];
export const clinicScope = (shop) => (shop?.type === "clinic" && shop.clinic_scope && shop.clinic_scope !== "full" ? shop.clinic_scope : null);
export const scopeAllows = (shop, to) => !clinicScope(shop) || !to || SCOPED_PATHS.some((p) => to === p || to.startsWith(`${p}?`) || to.startsWith(`${p}/`));
